/** Hours options for last-minute TimeFilterMenu (no All / Today / Tomorrow). */
export const LAST_MINUTE_HOURS_OPTIONS = [1, 3, 6, 12, 24] as const;

export type LastMinuteHours = (typeof LAST_MINUTE_HOURS_OPTIONS)[number];

/** Default window for last-minute requests and TimeFilter selection. */
export const DEFAULT_LAST_MINUTE_HOURS: LastMinuteHours = 6;

export function lastMinuteHoursLabel(hours: LastMinuteHours): string {
  return hours === 1 ? '1 hour' : `${hours} hours`;
}
